class EstatisticasArquivos {
  static get $inject() {
    return ['$scope', 'gql', '$filter']
  }

  constructor($scope, gql, $filter) {
    this.scope = $scope
    this.gql = gql
    this.apply = () => $scope.$apply()

    this.formatDate = date => {
      if (date) {
        return date.toISOString()
      }
    }

    this.currency = value => $filter('currency')(value ? value : 0, 'R$ ')

    this.chartValueFormat = (value, ratio) => {
      const porcento = Math.round(ratio * 10000) / 100
      const valor = $filter('currency')(value ? value : 0, 'R$ ')
      return `${porcento}% - ${valor}`
    }

    this.meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

    $scope.$watch(
      () => this.filter.filiaisIds,
      () => {
        if (this.filter.filiaisIds) this.reload()
      }
    )
  }

  $onInit() {
    const hoje = new Date()
    const inicioMes = new Date(hoje)

    inicioMes.setDate(1)

    this.filter = {
      tipoEmissao: this.tipoEmissao,
      periodo: {
        inicial: inicioMes,
        final: hoje
      },
      status: 'autorizada'
    }
  }

  reload() {
    const query = gql`
      query EstatisticasEmpresa($filter: NfeFilter!, $comparativoFilter: NfeFilter!, $anteriorFilter: NfeFilter!, $contratoId: Int!) {
        contrato: empresa(id: $contratoId){
          id
          estatisticas {
            nfes {
              valoresMensais(filter: $comparativoFilter) {
                date
                sum
                count
              }
              anterior: agregadores(filter: $anteriorFilter) {
                sum
                avg
                count
              }
              atual: agregadores(filter: $filter) {
                sum
                avg
                count
              }
              valoresPorUf(filter: $filter) {
                uf
                valor
              }
              valoresPorParticipante(filter: $filter) {
                nome
                cpfCnpj
                valor
              }
            }
          }
        }
      }
    `

    const filter = { ...this.filter }

    if (filter.periodo) {
      if (filter.periodo.inicial)
        filter.emissaoInicial = filter.periodo.inicial.toISOString()

      if (filter.periodo.final)
        filter.emissaoFinal = filter.periodo.final.toISOString()
    }

    delete filter.periodo

    filter.transferencia = false

    if (this.tipoEmissao === 'PROPRIA') {
      filter.finalidadeEmissaoIsNot = "4" // sem devoluções
    }

    if (filter.tipo === 'transferencia') {
      filter.transferencia = true
      delete filter.tipo
    } else if (filter.tipo === 'with_cte') {
      filter.with_cte = true
      delete filter.tipo
    }

    if (filter.busca) {
      const query = filter.busca
        .replace(/(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/g, "$1$2$3$4")
        .replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})-(\d{2})/g, "$1$2$3$4$5")

      filter.busca = {
        query: query,
        participante: this.tipoEmissao === 'PROPRIA' ? 'destinatario' : 'emitente'
      }
    }

    this.periodo = this.calculaPeriodo(filter)

    const hoje = new Date()
    const inicioPeriodo = new Date(hoje.getFullYear() - 3, 0, 1)
    const finalPeriodo = new Date(hoje.getFullYear(), hoje.getMonth(), 1)

    finalPeriodo.setTime(finalPeriodo.getTime() - (1000 * 60 * 60 * 24))

    const comparativoFilter = {
      ...filter,
      emissaoInicial: this.formatDate(inicioPeriodo),
      emissaoFinal: this.formatDate(finalPeriodo)
    }

    const anteriorFilter = {
      ...filter,
      emissaoInicial: this.formatDate(this.periodo.inicio),
      emissaoFinal: this.formatDate(this.periodo.fim)
    }

    this.loading = this
      .gql
      .query(query, { filter, anteriorFilter, comparativoFilter, contratoId: this.contratoId })
      .then(({ contrato: { estatisticas } }) => this.parse(estatisticas.nfes))
      .then(estatisticas => this.estatisticas = estatisticas)
      .then(() => this.apply())
      .catch(console.error)
  }

  calculaPeriodo({ emissaoInicial, emissaoFinal }) {
    const inicio = new Date(emissaoInicial)
    const final = new Date(emissaoFinal)

    const fim = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate() - 1)
    const diff = final.getTime() - inicio.getTime()

    inicio.setTime(inicio.getTime() - diff)

    return { inicio, fim }
  }

  submit(form) {
    if (form.$valid) {
      this.reload()
    } else {
      this.estatisticas = null
    }
  }

  parse({ valoresMensais, atual, anterior, valoresPorUf, valoresPorParticipante }) {
    const series = valoresMensais.groupBy(val => new Date(val.date).getUTCFullYear())

    const quantidades = Object
      .entries(series)
      .sort(([key1], [key2]) => key1 < key2 ? -1 : 1)
      .reduce((acc, [key, values]) => {
        acc[key] = this.parseMonthValues(values, 'count')
        return acc
      }, {})

    const valores = Object
      .entries(series)
      .sort(([key1], [key2]) => key1 < key2 ? -1 : 1)
      .reduce((acc, [key, values]) => {
        acc[key] = this.parseMonthValues(values, 'sum')
        return acc
      }, {})

    const valorTotal = {
      valor: atual.sum,
      crescimento: this.calculaCrescimento(anterior.sum, atual.sum)
    }

    const quantidade = {
      valor: atual.count,
      crescimento: this.calculaCrescimento(anterior.count, atual.count)
    }

    const valorMedio = {
      valor: atual.avg,
      crescimento: this.calculaCrescimento(anterior.avg, atual.avg)
    }

    return { quantidades, valores, valorTotal, valorMedio, quantidade, valoresPorUf, valoresPorParticipante }
  }

  parseMonthValues(values, key) {
    return this.meses.map((_mes, idx) => {
      const val = values.find(val => new Date(val.date).getUTCMonth() === idx)

      if (val) {
        return val[key] ? val[key] : 0
      }

      return null
    })
  }

  calculaCrescimento(anterior, atual) {
    atual = atual || 0
    anterior = anterior || 0

    if (anterior) {
      const calculo = (atual - anterior) * 100 / anterior

      return Math.round(calculo * 100) / 100
    }

    return 0
  }

  isTipoRecebidas() {
    return this.tipoEmissao === 'TERCEIROS'
  }
}

angular.module('eficienciaFiscalModule').component('estatisticasArquivos', {
  controller: EstatisticasArquivos,
  bindings: {
    contratoId: '<',
    tipoEmissao: '@',
    ferramenta: '@'
  },
  template: `
    <form class="fade-animation" name="form" ng-submit="$ctrl.submit(form)">
      <div class="row">
        <ef-filiais-selector
          class="form-group col-sm-12"
          name="empresasIds"
          ng-model="$ctrl.filter.filiaisIds"
          contrato-id="$ctrl.contratoId"
          ferramenta="{{ $ctrl.ferramenta }}"
          cache-as="estatisticas"
          required>
        </ef-filiais-selector>
        <div class="form-group col-sm-8 col-md-4">
          <label>
            Data de emissão
                        </label>
          <periodo-input name="emissao" ng-model="$ctrl.filter.periodo" required></periodo-input>
        </div>
        <div class="form-group col-sm-4 col-md-2">
          <label>
            Tipo
                            <i class="fa fa-trash-o text-danger cursor-pointer"
              ng-click="$ctrl.filter.tipo = undefined"
              ng-if="$ctrl.filter.tipo != undefined"></i>
          </label>
          <select class="form-control" ng-model="$ctrl.filter.tipo">
            <option value="0">Entrada</option>
            <option value="1">Saída</option>
            <option value="transferencia">Transferência</option>
            <option value="garantia">Garantia</option>
            <option value="with_cte">Possui CT-e</option>
          </select>
        </div>
        <div class="form-group col-sm-8 col-md-6">
          <label>
            Busca
                            <i class="fa fa-trash-o text-danger cursor-pointer"
              ng-click="$ctrl.filter.busca = undefined"
              ng-if="$ctrl.filter.busca"></i>
          </label>
          <input type="text" class="form-control" placeholder="Razão Social, CNPJ, Descrição do item"
            ng-model="$ctrl.filter.busca" ng-model-options="{ debounce: 500 }">
                    </div>
          <div class="form-group col-xs-12 col-sm-4 col-md-3 pull-right">
            <label for="" class="hidden-xs hidden-md hidden-lg">&nbsp;</label>
            <button type="submit" class="btn btn-primary btn-block"><i class="fa fa-refresh"></i> Atualizar</button>
          </div>
        </div>
            </form>
      <loading promise="$ctrl.loading">
        <highlighted ng-show="$ctrl.estatisticas == undefined">
          <main>Preencha o filtro acima para realizar uma consulta.</main>
        </highlighted>
        <promise-tracker ng-hide="$ctrl.estatisticas == undefined" promise="$ctrl.loading" active="active">
          <div ng-if="!active" class="row">
            <div class="col-xs-12 microcharts">
              <microchart
                label="Valor total das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}"
                valor="{{$ctrl.currency($ctrl.estatisticas.valorTotal.valor)}}"
                crescimento="$ctrl.estatisticas.valorTotal.crescimento"
                periodo="$ctrl.periodo">
              </microchart>

              <microchart
                label="Quantidade das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}"
                valor="{{$ctrl.estatisticas.quantidade.valor}}"
                crescimento="$ctrl.estatisticas.quantidade.crescimento"
                periodo="$ctrl.periodo">
              </microchart>

              <microchart
                label="Valor médio das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}"
                valor="{{$ctrl.currency($ctrl.estatisticas.valorMedio.valor)}}"
                crescimento="$ctrl.estatisticas.valorMedio.crescimento"
                periodo="$ctrl.periodo">
              </microchart>
            </div>

            <div class="col-xs-12">
              <comparativo-anual-chart
                id="'valor-total-mes'"
                data="$ctrl.estatisticas.valores"
                labels="$ctrl.meses"
                name="Valor total por mês das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}"
                format="$ctrl.currency"
                y-label="Valor total">
              </comparativo-anual-chart>
            </div>

            <div class="col-xs-12">
              <comparativo-anual-chart
                id="'quantidade-mes'"
                data="$ctrl.estatisticas.quantidades"
                labels="$ctrl.meses"
                name="Quantidade por mês das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}"
                y-label="Quantidade">
              </comparativo-anual-chart>
            </div>

            <div class="col-xs-12 double-chart">
              <div class="pane">
                <highlighted ng-if="$ctrl.estatisticas.valoresPorUf.length < 2">
                  <main>Porcentagem média por estado das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}</main>
                  <secondary>Não há dados suficientes neste período</secondary>
                </highlighted>

                <div ng-if="$ctrl.estatisticas.valoresPorUf.length > 1">
                  <h1 class="text-center">Porcentagem média por estado das notas {{::$ctrl.isTipoRecebidas() ? 'recebidas' : 'emitidas' }}</h1>
                  <c3chart bindto-id="quantidade-por-estado">
                    <chart-tooltip value-format-function="$ctrl.chartValueFormat"></chart-tooltip>
                    <chart-column
                      ng-repeat="uf in $ctrl.estatisticas.valoresPorUf"
                      column-id="{{uf.uf}}"
                      column-values="{{uf.valor}}"
                      column-type="pie"
                    />
                    <chart-pie expand="true" />
                  </c3chart>
                </div>
              </div>

              <div class="pane">
                <highlighted ng-if="$ctrl.estatisticas.valoresPorParticipante.length < 2">
                  <main>10 maiores {{::$ctrl.isTipoRecebidas() ? 'fornecedores' : 'clientes' }}</main>
                  <secondary>Não há dados suficientes neste período</secondary>
                </highlighted>

                <div ng-if="$ctrl.estatisticas.valoresPorParticipante.length > 1">
                  <h1 class="text-center">10 maiores {{::$ctrl.isTipoRecebidas() ? 'fornecedores' : 'clientes' }}</h1>
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>CPF/CNPJ</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr ng-repeat="participante in $ctrl.estatisticas.valoresPorParticipante">
                        <td>{{ participante.nome | limitToDots: 30}}</td>
                        <td>{{ participante.cpfCnpj | cpfCnpj }}</td>
                        <td>{{ participante.valor | currency: 'R$ '}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </promise-tracker>
      </loading>
  `
})
